import React from 'react'

export default function Lighttext(props) {
  return (
    <>
       <div style={{color:'#534d4d' , fontSize:'15px',marginTop:'25px',fontWeight:'300' , marginLeft:'25px'}}>
            <span >{props.text}</span></div> 
      
    </>
  )
}
